module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "insights_primary"
  }, [(_vm.loadingInsights || _vm.loadingWorkbench) ? _c('v-overlay', {
    staticClass: "insightsOverlay",
    attrs: {
      "value": _vm.showOverlay,
      "absolute": "",
      "light": ""
    }
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "align-content": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "text-h5 text-center",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.overlayMessage) + "\n        ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "indeterminate": "",
      "height": "8"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.insightUpdateError) ? _c('div', {
    staticClass: "insightsMessage text-h5 red--text",
    staticStyle: {
      "margin-top": "10vh"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.overlayMessage) + "\n  ")]) : (_vm.initialOverlay) ? _c('div', {
    staticClass: "insightsMessage text-h4",
    staticStyle: {
      "margin-top": "20vh"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.overlayMessage) + "\n  ")]) : _c('div', {
    staticClass: "pa-6",
    style: (_vm.loadingInsights ? 'opacity: 0.1' : ''),
    attrs: {
      "id": "primaryInsightCardsContainer"
    }
  }, [_c('div', {
    staticClass: "insightsCard mb-4"
  }, [(_vm.isHouseholdDataAvailable) ? _c('v-card', {
    attrs: {
      "elevation": "2",
      "name": "householdIdCards",
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "insightsCardTitle text-subtitle-1"
  }, [_vm._v("household id")]), _vm._v(" "), _c('div', {
    staticClass: "pl-8"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.houseIcon,
      "width": "2em"
    }
  })], 1)]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card', {
    staticClass: "justify-center d-flex flex-wrap ml-10 mr-10 mb-2",
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, _vm._l((_vm.householdCardData), function(data) {
    return _c('v-card', {
      key: data.idType,
      staticClass: "ml-6 mr-6",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "text-body-1 text-center"
    }, [_vm._v("\n              " + _vm._s(data.idType) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-h5 font-weight-bold text-center"
    }, [_vm._v("\n              " + _vm._s(_vm.formattedCount(data.count)) + "\n            ")])])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "insightsCard"
  }, [(_vm.isDeviceDataAvailable) ? _c('v-card', {
    staticClass: "deviceIdCards",
    attrs: {
      "elevation": "2",
      "name": "deviceIdCards",
      "outlined": ""
    }
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "insightsCardTitle text-subtitle-1"
  }, [_vm._v("device id")]), _vm._v(" "), _c('div', [_c('v-img', {
    attrs: {
      "src": _vm.deviceIcon,
      "width": "4.5em"
    }
  })], 1)]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card', {
    class: _vm.deviceIdCardsClass,
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.deviceCardData), function(data) {
    return _c('v-card', {
      key: data.idType,
      staticClass: "deviceIdCountCard ml-lg-6 mr-lg-6 mb-2",
      attrs: {
        "flat": ""
      }
    }, [_c('div', {
      staticClass: "text-uppercase text-body-1 text-center"
    }, [_vm._v("\n              " + _vm._s(data.idType) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-h5 font-weight-bold text-center"
    }, [_vm._v("\n              " + _vm._s(_vm.formattedCount(data.count)) + "\n            ")])])
  }), 1)], 1) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e3089c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/insights/primary.vue
// module id = 1809
// module chunks = 0